import React from "react";

export type CategoryTabKey =
    | "everything"
    | "subfolders"
    | "pages"
    | "questions"
    | "links"
    | "documents"
    | "requests";

export interface TabCounts {
    subfolders: number;
    pages: number;
    questions: number;
    links: number;
    documents: number;
    requests: number;
}

interface Props {
    active: CategoryTabKey;
    counts: TabCounts;
    onChange: (key: CategoryTabKey) => void;
}

const TABS: { key: CategoryTabKey; label: string }[] = [
    { key: "everything", label: "Everything" },
    { key: "subfolders", label: "Folders" },
    { key: "pages", label: "Pages" },
    { key: "questions", label: "Questions" },
    { key: "links", label: "Links" },
    { key: "documents", label: "Documents" },
    { key: "requests", label: "Requests" },
];

export default function CategoryTabs({ active, counts, onChange }: Props) {
    const everything = counts.subfolders + counts.pages + counts.questions + counts.links + counts.documents + counts.requests;

    function countFor(key: CategoryTabKey): number {
        if (key === "everything") return everything;
        return counts[key];
    }

    return (
        <div className="m-cat-tabs">
            {TABS.map(t => (
                <button
                    key={t.key}
                    type="button"
                    className={"m-cat-tab" + (active === t.key ? " active" : "")}
                    onClick={() => onChange(t.key)}
                >
                    <span>{t.label}</span>
                    <span className="m-cat-tab-count">{countFor(t.key)}</span>
                </button>
            ))}
        </div>
    );
}
